<template>
  <div class='text-center pt-5 '>
    <h2>{{ msg }}</h2>
    <h4 class="h4 mb-3  font-weight-normal">404 Page not found</h4>
    <div class="col-md-2 col-centered">
      <router-link to="/">
        <button class="btn btn-lg btn-primary btn-block mt-3 btn-success" type="button">Go to login page</button>
      </router-link>
    </div>
    <p class="mt-5 mb-3 text-muted">&copy; Ragnar Infosec 2018</p>
  </div>
</template>

<script>
export default {
  name: 'notFound',
  data () {
    return {
      msg: 'iLog Lite by Ragnar Infosec'
    }
  }
}
</script>

<style scoped>
.col-centered {
  float: none;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/notFound.vue